(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7911],{

/***/ 60216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O6": function() { return /* binding */ AnimateCarouselImage; },
/* harmony export */   "bv": function() { return /* binding */ AnimateIn; },
/* harmony export */   "ds": function() { return /* binding */ AnimateBugLeft; },
/* harmony export */   "nw": function() { return /* binding */ AnimateBugRight; }
/* harmony export */ });
/* unused harmony export AnimateMobileCarouselImage */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67285);



const AnimateIn = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        initial: {
            bottom: -200
        },
        animate: {
            bottom: -38
        },
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8,
            delay: 1
        },
        style: {
            position: "fixed",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2000
        },
        children: children
    });
};
const AnimateBugLeft = (param)=>{
    let { loaded , children  } = param;
    const orig = {
        left: -300,
        top: 0,
        opacity: 0
    };
    const final = {
        left: -120,
        top: 125,
        opacity: 1
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        initial: orig,
        animate: loaded ? final : orig,
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8,
            delay: 1
        },
        style: {
            position: "absolute",
            width: 250
        },
        children: children
    });
};
const AnimateBugRight = (param)=>{
    let { loaded , children  } = param;
    const orig = {
        right: -275,
        top: -95,
        opacity: 0
    };
    const final = {
        right: -95,
        top: 30,
        opacity: 1
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        initial: orig,
        animate: loaded ? final : orig,
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8,
            delay: 1
        },
        style: {
            position: "absolute",
            width: 250
        },
        children: children
    });
};
const AnimateCarouselImage = (param)=>{
    let { loaded , children  } = param;
    const orig = {
        bottom: -300,
        opacity: 0
    };
    const final = {
        bottom: -20,
        opacity: 1
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        initial: orig,
        animate: loaded ? final : orig,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 0.4
        },
        className: "absolute border-2 right-0 sm:w-[280px] md:w-[300px] lg:w-[450px] xl:w-[450px]",
        children: children
    });
};
const AnimateMobileCarouselImage = (param)=>{
    let { loaded , children  } = param;
    const orig = {
        bottom: -300,
        opacity: 0
    };
    const final = {
        bottom: 30,
        opacity: 1
    };
    return /*#__PURE__*/ _jsx(motion.div, {
        initial: orig,
        animate: loaded ? final : orig,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 0.4
        },
        className: "absolute bottom-0 border-2 border-red-500 h-[200px] w-[200px]",
        children: children
    });
};


/***/ }),

/***/ 70358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useMediaQuery = (width)=>{
    const [targetReached, setTargetReached] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const updateTarget = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e)=>{
        if (e.matches) {
            setTargetReached(true);
        } else {
            setTargetReached(false);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const media = window.matchMedia("(max-width: ".concat(width, "px)"));
        media.addEventListener("change", (e)=>updateTarget(e));
        // Check on mount (callback is not called until a change occurs)
        if (media.matches) {
            setTargetReached(true);
        }
        return ()=>media.removeEventListener("change", (e)=>updateTarget(e));
    }, [
        width,
        updateTarget
    ]);
    return targetReached;
};


/***/ }),

/***/ 77911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/common/HighlightLogo/HighlightLogo.tsx + 2 modules
var HighlightLogo = __webpack_require__(44688);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.module.scss
var Navbar_module = __webpack_require__(36109);
var Navbar_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js + 4 modules
var popover = __webpack_require__(61761);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(31407);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(53854);
// EXTERNAL MODULE: ./components/common/Navbar/ResourceDropdown.module.scss
var ResourceDropdown_module = __webpack_require__(18419);
var ResourceDropdown_module_default = /*#__PURE__*/__webpack_require__.n(ResourceDropdown_module);
;// CONCATENATED MODULE: ./components/common/Navbar/ResourceDropdown.tsx









const ResourceDropdown = (param)=>{
    let { isOpen  } = param;
    const [isShowing, setIsShowing] = (0,react.useState)(false);
    const otherLinks = [
        {
            title: "Status Page",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiCloud */.aOQ, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "https://highlight.hyperping.io/"
        },
        {
            title: "Community",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiUsers */.AYC, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "https://discord.gg/yxaXEAqgwN"
        },
        {
            title: "Changelog",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiClipboardList */.sQ2, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "https://www.highlight.io/docs/general/changelog/overview"
        },
        {
            title: "Feedback",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiChat */.wIw, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "https://feedback.highlight.run"
        },
        {
            title: "Github",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiFillGithub */.RrF, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "https://github.com/highlight/highlight"
        },
        {
            title: "Blog",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiCollection */.CAn, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "/blog",
            sameTab: true
        },
        {
            title: "Documentation",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiDocumentSearch */.m3O, {
                className: (ResourceDropdown_module_default()).copyOnLight
            }),
            link: "/docs",
            sameTab: true
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
        children: (param)=>/*#__PURE__*/ {
            let { open  } = param;
            return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                        onMouseEnter: ()=>setIsShowing(true),
                        onMouseLeave: ()=>setIsShowing(false),
                        className: (ResourceDropdown_module_default()).popoverButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: classnames_default()((ResourceDropdown_module_default()).headerButton, {
                                [(ResourceDropdown_module_default()).white]: isShowing
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[6.5px] items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy2",
                                        children: "Resources"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaChevronDown */.RiI, {
                                        className: "w-[10px]"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        show: isShowing,
                        onMouseEnter: ()=>setIsShowing(true),
                        onMouseLeave: ()=>setIsShowing(false),
                        enter: "transition ease-out duration-200",
                        enterFrom: "opacity-0 translate-y-1",
                        enterTo: "opacity-100 translate-y-0",
                        leave: "transition ease-in duration-150",
                        leaveFrom: "opacity-100 translate-y-0",
                        leaveTo: "opacity-0 translate-y-1",
                        children: !isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                            className: (ResourceDropdown_module_default()).popover,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ResourceDropdown_module_default()).popoverPanel,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ResourceDropdown_module_default()).gridContainer,
                                    children: otherLinks.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: item.link,
                                            target: item.sameTab ? "" : "_blank",
                                            rel: "noreferrer",
                                            className: (ResourceDropdown_module_default()).gridItem,
                                            children: [
                                                item.icon,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    children: item.title
                                                })
                                            ]
                                        }, index))
                                })
                            })
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var Navbar_ResourceDropdown = (ResourceDropdown);

// EXTERNAL MODULE: ./node_modules/react-github-btn/index.js
var react_github_btn = __webpack_require__(62719);
;// CONCATENATED MODULE: ./public/images/CrossIcon.tsx


function CrossIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
            fill: "#72E4FC"
        })
    });
}
/* harmony default export */ var images_CrossIcon = (CrossIcon);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 191 modules
var motion = __webpack_require__(67285);
// EXTERNAL MODULE: ./components/GithubPopup/GithubPopup.module.scss
var GithubPopup_module = __webpack_require__(38921);
var GithubPopup_module_default = /*#__PURE__*/__webpack_require__.n(GithubPopup_module);
// EXTERNAL MODULE: ./components/MediaQuery/MediaQuery.tsx
var MediaQuery = __webpack_require__(70358);
// EXTERNAL MODULE: ./components/Animate.tsx
var Animate = __webpack_require__(60216);
;// CONCATENATED MODULE: ./components/GithubPopup/GithubPopup.tsx








const GithubPopup = ()=>{
    const is400 = (0,MediaQuery/* useMediaQuery */.a)(400);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: is400 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileGithubPopup, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopGithubPopup, {})
    });
};
const MobileGithubPopup = ()=>{
    const [hide, setHide] = (0,react.useState)(false);
    return hide ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateIn */.bv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (GithubPopup_module_default()).mobilePopup,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        fontSize: 18,
                        fontWeight: "400",
                        color: "white",
                        overflow: "hidden",
                        whiteSpace: "nowrap"
                    },
                    children: "Star us on GitHub"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_github_btn/* default */.Z, {
                        href: "https://github.com/highlight/highlight",
                        "data-color-scheme": "no-preference: light; light: light; dark: light;",
                        "data-size": "large",
                        "data-show-count": "true",
                        "aria-label": "Star highlight/highlight on GitHub",
                        children: "Star"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: ()=>setHide(true),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_CrossIcon, {})
                })
            ]
        })
    });
};
const DesktopGithubPopup = ()=>{
    const [hide, setHide] = (0,react.useState)(false);
    return hide ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        initial: {
            bottom: -200
        },
        animate: {
            bottom: 10
        },
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8,
            delay: 1
        },
        style: {
            position: "fixed",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2000
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (GithubPopup_module_default()).desktopPopup,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        fontSize: 18,
                        fontWeight: "400",
                        color: "white",
                        overflow: "hidden",
                        whiteSpace: "nowrap"
                    },
                    children: "Star us on GitHub"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_github_btn/* default */.Z, {
                        href: "https://github.com/highlight/highlight",
                        "data-color-scheme": "no-preference: light; light: light; dark: light;",
                        "data-size": "large",
                        "data-show-count": "true",
                        "aria-label": "Star highlight/highlight on GitHub",
                        children: "Star"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: ()=>setHide(true),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_CrossIcon, {})
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@docsearch/react/dist/esm/DocSearch.js + 65 modules
var DocSearch = __webpack_require__(61627);
// EXTERNAL MODULE: ./node_modules/@docsearch/css/dist/style.css
var style = __webpack_require__(26428);
;// CONCATENATED MODULE: ./components/common/Navbar/Navbar.tsx















const Navbar = (param)=>{
    let { hideFreeTrialText , isDocsPage , hideBanner , fixed , title  } = param;
    const [scrolled, setScrolled] = (0,react.useState)(false);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [prevY, setPrevY] = (0,react.useState)(0);
    const changeBackground = ()=>{
        const currentScrollPos = window.pageYOffset;
        if (window.scrollY > 60 && prevY < currentScrollPos) {
            setScrolled(true);
        } else if (window.scrollY > 60 && prevY > currentScrollPos) {
            setScrolled(false);
        }
        setPrevY(currentScrollPos);
    };
    (0,react.useEffect)(()=>{
        changeBackground();
        window.addEventListener("scroll", changeBackground);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GithubPopup, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Navbar_module_default()).container, {
                    [(Navbar_module_default()).hide]: scrolled && !fixed,
                    [(Navbar_module_default()).fixed]: fixed
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                    className: classnames_default()({
                        [(Navbar_module_default()).mobileHeader]: isOpen
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((Navbar_module_default()).header, (Navbar_module_default()).headerInner, {
                            [(Navbar_module_default()).openHeader]: isOpen,
                            [(Navbar_module_default()).headerBorder]: prevY != 0
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((Navbar_module_default()).navContainer, (Navbar_module_default()).headerLeft),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        className: (Navbar_module_default()).urlStyle,
                                        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightLogo/* HighlightLogoWhite */.s, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightLogo/* HighlightLogo */.R, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        emphasis: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: classnames_default()((Navbar_module_default()).navTitle, {
                                                [(Navbar_module_default()).copyOnDark]: isOpen,
                                                [(Navbar_module_default()).copyOnLight]: !isOpen
                                            }),
                                            children: title
                                        })
                                    }),
                                    isDocsPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(DocSearch/* DocSearch */.F, {
                                        placeholder: "Search the highlight.io docs",
                                        appId: "JGT9LI80J2",
                                        indexName: "highlight",
                                        apiKey: "ac336720d8f4f996abe3adee603a1c84"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Navbar_module_default()).navMenu,
                                onClick: ()=>setIsOpen(!isOpen),
                                children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineClose */.oHP, {
                                    className: (Navbar_module_default()).copyOnDark
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMenu */.qTj, {})
                            }),
                            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Navbar_module_default()).mobileMenu,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: classnames_default()((Navbar_module_default()).menuList, (Navbar_module_default()).header),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/pricing",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Pricing"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/blog",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Blog"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "https://careers.highlight.run",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Careers"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/docs",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Docs"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Navbar_module_default()).menuButtons,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                href: "https://app.highlight.io/?sign_up=1",
                                                children: "Get Started"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                type: "copy3",
                                                emphasis: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://app.highlight.io/",
                                                    className: (Navbar_module_default()).menuItem,
                                                    children: "Sign In"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isDocsPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((Navbar_module_default()).navContainer, (Navbar_module_default()).header, (Navbar_module_default()).headerCenter),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/pricing",
                                        className: (Navbar_module_default()).headerButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            children: "Pricing"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/customers",
                                        className: (Navbar_module_default()).headerButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            children: "Customers"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blog",
                                        className: (Navbar_module_default()).headerButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            children: "Blog"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_ResourceDropdown, {
                                        isOpen: scrolled && !fixed
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((Navbar_module_default()).navContainer, (Navbar_module_default()).header, (Navbar_module_default()).headerRight),
                                children: [
                                    !isDocsPage && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/docs",
                                        className: classnames_default()((Navbar_module_default()).headerButton, (Navbar_module_default()).headerButtonRight),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            children: "Docs"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://app.highlight.io/",
                                        className: (Navbar_module_default()).headerButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            children: "Sign in"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                        href: "https://app.highlight.io/?sign_up=1",
                                        className: (Navbar_module_default()).signUpButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            emphasis: true,
                                            children: "Sign up"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Navbar_module_default()).socialButtonContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://github.com/highlight/highlight",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: classnames_default()((Navbar_module_default()).socialButtonWrapper, (Navbar_module_default()).socialButtonWrapperLeft),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiFillGithub */.RrF, {
                                                    className: classnames_default()((Navbar_module_default()).socialButton)
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Navbar_module_default()).socialButtonDivider
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://discord.gg/yxaXEAqgwN",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: classnames_default()((Navbar_module_default()).socialButtonWrapper, (Navbar_module_default()).socialButtonWrapperRight),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaDiscord */.j2d, {
                                                    className: classnames_default()((Navbar_module_default()).socialButton)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Navbar_Navbar = (Navbar);


/***/ }),

/***/ 38921:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobilePopup":"GithubPopup_mobilePopup__FKeVw","desktopPopup":"GithubPopup_desktopPopup__yFGtn"};

/***/ }),

/***/ 18419:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerButton":"ResourceDropdown_headerButton__mjZ65","popoverButton":"ResourceDropdown_popoverButton__obeHV","popover":"ResourceDropdown_popover__ZWDlP","popoverPanel":"ResourceDropdown_popoverPanel__1BfEb","copyOnLight":"ResourceDropdown_copyOnLight__mABGq","copyOnDark":"ResourceDropdown_copyOnDark__Bm6cX","white":"ResourceDropdown_white__chyYq","gridContainer":"ResourceDropdown_gridContainer__RApN7","gridItem":"ResourceDropdown_gridItem__R4CG6"};

/***/ })

}]);